import {
  CHECK_CARD_ERRORS_STEP,
  CONFIRMATION_FORM_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP,
  WHICH_ACCOUNT_STEP
} from '#client/constants/transfer';

export const TRY_ADD_CARD_AGAIN_STEP = 'try_add_card_again_step';
export const ACCOUNT_COULD_NOT_SET_UP = 'account_could_not_set_up';
export const SETTING_UP_ACCOUNT = 'setting_up_account';
export const LOADING_STEP = 'loading_step';

export const INSTANT_DEPOSIT_ERROR_CODES = {
  INSUFFICIENT_FUNDS: '51'
};

export const INSTANT_TRANSFER_STATUS = {
  PENDING: 'pending',
  PROCESSED: 'processed',
  CANCELLED: 'cancelled',
  FAILED: 'failed'
};

export const INSTANT_DEPOSIT_STEP_LIST = [
  TRY_ADD_CARD_AGAIN_STEP,
  SETTING_UP_ACCOUNT,
  ACCOUNT_COULD_NOT_SET_UP,
  CHECK_CARD_ERRORS_STEP,
  WHICH_ACCOUNT_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP,
  LOADING_STEP,
  CONFIRMATION_FORM_STEP
];

export const MODAL_ACTION = {
  TRY_AGAIN: 'try_again',
  GO_TO_WHICH_CARD_FORM: 'go_to_which_card_form',
  GO_TO_IS_THIS_CORRECT_FORM: 'go_to_is_this_correct_form',
  GO_TO_CONFIRMATION: 'go_to_confirmation',
  GO_TO_HOW_MUCH_FORM: 'go_to_how_much_form',
  GO_TO_CHECK_CARD_ERRORS: 'go_to_check_card_errors',
  GO_TO_LOADING_STEP: 'go_to_loading_step',
  GO_TO_ACCOUNT_COULD_NOT_SET_UP: 'go_to_account_could_not_set_up',
  BACK: 'back'
};

export const CARD_ERROR_MESSAGES = {
  COULD_NOT_PROCESS_WITH_THIS_CARD: {
    buttonLabel: 'Add another card',
    screenName: 'card_unauthorized_error',
    errorMessage: 'We can’t process transactions with this card',
    errorDescription: 'To make a deposit, please try another card.'
  },
  COULD_NOT_VERIFY_ADDRESS: {
    buttonLabel: 'Add card again',
    screenName: 'address_error_instantdep',
    errorMessage: 'We could not verify the address with this card',
    errorDescription:
      'Please update your address with your bank and re-add your card. Or try another debit card.'
  },
  NOT_DEBIT_CARD: {
    screenName: 'not_debit_card_error',
    errorMessage: 'This is not a debit card',
    errorDescription: 'Please try again with a debit card.'
  },
  PENDING_APPROVAL: {
    screenName: 'card_pending_approval_error',
    errorMessage: 'This card is still pending approval',
    errorDescription:
      'You must wait for this card to be approved for deposits. Or you can try another card now.'
  },
  EXPIRED: {
    screenName: 'card_expired_error',
    errorMessage: 'This card is expired',
    errorDescription: 'Please use another debit card.'
  }
};

export const DASHBOARD_NOT_FUND_PAGE = 'dashboard-notfunded';
